/* Somewhere to land that is not a blank page (S3.1).
 *
 * A person opening an ERP for the first time does not know what a DocType is
 * and should not have to. This says what the app is for in four sentences and
 * puts the things most people came to do within one click.
 */
import { Cards } from '@jackdesk/erp-kit'
import { MENU, routeFor } from './nav'

const START: { label: string; doctype: string; what: string }[] = [
  { label: 'Raise an invoice', doctype: 'Sales Invoice', what: 'Bill a customer for something you sold' },
  { label: 'Enter a bill', doctype: 'Purchase Invoice', what: 'Record something a supplier charged you' },
  { label: 'Record a payment', doctype: 'Payment Entry', what: 'Money that came in, or went out' },
  { label: 'Look at the accounts', doctype: 'Account', what: 'Every account in your ledger' },
  { label: 'Check stock', doctype: 'Stock Entry', what: 'What moved in, out or between warehouses' },
  { label: 'Add an item', doctype: 'Item', what: 'Something you buy, make or sell' },
]

export function Home({ onOpen, onGo }: { onOpen: (doctype: string) => void; onGo: (to: string) => void }) {
  return (
    <div className="page" style={{ display: 'grid', gap: 22 }}>
      <div>
        <h1>Your books, in plain words</h1>
        <p className="muted" style={{ maxWidth: '62ch', marginTop: 6 }}>
          Everything here writes to the same ledger your accountant and auditor work from. Start
          with one of these, use the menu, or press <span className="kbd">Ctrl K</span> to search
          for anything.
        </p>
      </div>

      {/* The business, before the shortcuts. ERPNext's own number cards, so
          these are the figures an accountant already recognises. */}
      <Cards module="Accounts" onOpen={onOpen} />

      <section style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
        {START.map((s) => (
          <button key={s.doctype} className="card card-pad" onClick={() => onOpen(s.doctype)}
                  style={{ textAlign: 'left', cursor: 'pointer', font: 'inherit', color: 'inherit' }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>{s.label}</div>
            <div className="small muted">{s.what}</div>
          </button>
        ))}
      </section>

      <section>
        <h2 style={{ marginBottom: 10 }}>Everything else</h2>
        <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))' }}>
          {MENU.map((s) => (
            <div key={s.title} className="card card-pad">
              <h3 style={{ marginBottom: 8 }}>{s.title}</h3>
              <div className="stack" style={{ gap: 1 }}>
                {s.entries.slice(0, 4).map((e) => (
                  <button key={e.doctype ?? e.report ?? e.label} className="navitem"
                          onClick={() => onGo(routeFor(e))}>
                    <span className="grow truncate">{e.label}</span>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}
